import { Stack } from '@mui/material'
import ReactMarkdown from 'react-markdown'

import { PromptDraftRow } from './PromptDraftRowBulkImport'

import { useBulkImportStore, useCardTypeBulkImportStore } from '@/components/BulkImportModal/hooks/useBulkImportStore'
import { bulkImportStoreActions } from '@/components/BulkImportModal/store/bulk-import.store'
import { checkTypeCardActivity } from '@/utils/checkTypeCard'
import { ReactComponent as ChattyAI } from '@/assets/icons/chatty-avatar.svg'

export function PromptFieldBulkImport() {
  const cardType = useCardTypeBulkImportStore()
  const draftCards = useBulkImportStore(store => store.cardsDraft)

  const { isRepeat } = checkTypeCardActivity(cardType)

  const arrayDraftCards = Array.from(draftCards)

  const instructionsMarkdown = `📋 Paste your content above or let me do the work! Click ✨ “**Generate with AI**” to create content with me, then hit ‘Add to Page’ when you’re ready! ✅`

  const isEmpty = arrayDraftCards.length === 0

  return (
    <Stack
      className={!isEmpty ? 'flex-col' : ''}
      gap="10px"
      sx={{
        height: '100%',
        ...(isEmpty && {
          justifyContent: 'center',
          alignItems: 'center',
        }),
      }}
    >
      {isEmpty ? (
        <Stack alignItems="center" gap="10px" justifyContent="center" width={300}>
          <Stack
            sx={{
              padding: '12px',
              borderRadius: '8px',
              background: '#F9FAFB',
            }}
          >
            <ReactMarkdown>{instructionsMarkdown}</ReactMarkdown>
          </Stack>
          <ChattyAI />
        </Stack>
      ) : null}

      {!isEmpty &&
        arrayDraftCards.map(([cardId, cardData], index) => (
          <PromptDraftRow
            key={cardId}
            cardData={cardData}
            cardId={cardId}
            index={index}
            isRepeat={isRepeat}
            onDelete={() => {
              bulkImportStoreActions.deleteCardDraftEntry(cardId)
            }}
            onSetValue={(key, value) => {
              bulkImportStoreActions.updateCardDraftEntry(cardId, { [key]: value })
            }}
          />
        ))}
    </Stack>
  )
}
